import { render } from "./edit-password-modal.vue?vue&type=template&id=3cc9e1b4"
import script from "./edit-password-modal.vue?vue&type=script&lang=js"
export * from "./edit-password-modal.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1917936756/src/quotation-sales/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__